import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'activeOutlet',
            'activeTill',
            'startDate',
            'endDate',
            'startMonth',
            'endMonth',
            'dateFilter',
            'monthFilter',
        ]),

        /**
         * Encoded url params
         */
        filterParams() {
            const param = Object.assign(
                { outlet_id: this.activeOutlet },
                { till_id: this.activeTill },
                this.dateFilter,
                this.monthFilter,
            );

            return $.param(param);
        },
    },

    watch: {
        activeOutlet(newVal, oldVal) {
            this.$emit('outlet-changed', newVal);
        },

        activeTill(newVal, oldVal) {
            this.$emit('till-changed', newVal);
        },

        dateFilter(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.$emit('date-changed', newVal);
        },

        monthFilter(newVal, oldVal) {
            if (newVal == oldVal) return;
            this.$emit('month-changed', newVal);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/report-filter.js